<template>
  <div class="root-wrapper">
    <keep-alive :exclude="['NewAd', 'editAd', 'Admin', 'Details']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'root'
}
</script>
<style lang="scss" scoped>
.root-wrapper {
  flex-grow: 1;
  display: flex;
  position: relative;
}
</style>
